import { render } from "./App.vue?vue&type=template&id=eba2e59c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "D:\\TuaN\\TuaN\\Projects\\2023\\DigitDock\\Sources\\FiFlex-Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__